export const TYPES_CAR = ['CDV', 'CD', 'D', 'EXP', 'OV', 'FS'];
